import * as React from 'react';
export const billableItemSvg = React.forwardRef(function billableItemSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.587.908a.6.6 0 0 1 .492.692l-1.513 9a.6.6 0 0 1-1.183-.2l1.514-9a.6.6 0 0 1 .69-.492Zm4.54 0a.6.6 0 0 1 .492.692l-1.513 9a.6.6 0 0 1-1.184-.2l1.514-9a.6.6 0 0 1 .69-.492Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11 3.182a.601.601 0 0 1 0 1.2H1.79a.6.6 0 1 1 0-1.2H11Zm-.79 4.435a.601.601 0 0 1 0 1.2H1a.6.6 0 1 1 0-1.2h9.21Z',
    }),
  );
});
billableItemSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var billableItem = {
  category: 'icon',
  colorable: true,
  name: 'billableItem',
  svg: billableItemSvg,
};
